import { Block } from 'slate';
import Logger from '../../../../../../utility/services/Logger';
import { getLevel } from './findBulletLevel';

export default (
  editor,
  shiftKey,
  paraBlock,
  index,
  paraBlocks,
  prevSiblingNewIndices,
  initialDoc,
) => {
  const { document, focusBlock, selection } = editor.value;
  const level = getLevel({ document, currentBlock: paraBlock });
  const parentListItem = document.getParent(paraBlock.key || focusBlock.key);

  if (parentListItem.type !== 'list_item') return false;

  const parentUL = document.getParent(parentListItem.key);
  const indexOfParentListItem = parentUL.nodes
    .toArray()
    .indexOf(parentListItem);

  const parentULSize = parentUL.nodes.size;
  if (shiftKey) {
    const upperLI = document.getParent(parentUL.key);
    const upperUL = document.getParent(upperLI.key);
    const upperLIIndex = upperUL.nodes.toArray().indexOf(upperLI);

    const liToMove = parentUL.nodes
      .toArray()
      .slice(indexOfParentListItem + 1, parentULSize);

    if (level !== 0) {
      /**
       * Check if parent is already shifted
       * if prevLevel !== currLevel || parent !== listitem
       */
      const prevPara = index && paraBlocks[index - 1];

      const prevParaInitialLevel =
        prevPara &&
        getLevel({
          document: initialDoc,
          currentBlock: prevPara,
        });

      const prevParaCurrLevel =
        prevPara &&
        getLevel({
          document,
          currentBlock: prevPara,
        });

      if (
        prevParaInitialLevel !== prevParaCurrLevel &&
        prevParaCurrLevel < level
      )
        return false;

      /**
       * Check if previous sibling of current list item is shifted already to an index
       */
      let insertIndex = upperLIIndex + 1;
      if (prevSiblingNewIndices && prevSiblingNewIndices[level]) {
        insertIndex = prevSiblingNewIndices[level] + 1;
      }

      editor.moveNodeByKey(parentListItem.key, upperUL.key, insertIndex); // works

      // eslint-disable-next-line no-param-reassign
      if (prevSiblingNewIndices) prevSiblingNewIndices[level] += 1;

      liToMove.forEach((item) => {
        const updatedParentListItem = editor.value.document.getNode(
          parentListItem.key,
        ); // { abcd <-- qrst}

        const parentListItemNodes = updatedParentListItem.nodes.toArray();
        const parentListItemNodesLength = parentListItemNodes.length;
        if (parentListItemNodesLength > 1) {
          editor.moveNodeByKey(
            item.key,
            updatedParentListItem.nodes.toArray()[1].key,
            updatedParentListItem.nodes.toArray()[1].nodes.size,
          ); // qrst
        } else {
          editor
            .moveNodeByKey(item.key, updatedParentListItem.key, 1)
            .wrapBlockByKey(item.key, 'unordered_list');
        }
      });
      return false;
    }

    if (level === 0) {
      /**
       * Check if parent is already shifted
       * if prevLevel !== currLevel || parent !== listitem
       */

      if (parentListItem.type !== 'list_item') return true;
      const prevPara = index && paraBlocks[index - 1];
      const prevParaParent = prevPara && document.getParent(prevPara.key);
      const prevParaInitialLevel =
        prevPara &&
        getLevel({
          document: initialDoc,
          currentBlock: prevPara,
        });

      const prevParaCurrLevel =
        prevPara &&
        getLevel({
          document,
          currentBlock: prevPara,
        });

      const currParaInitialLevel = getLevel({
        document: initialDoc,
        currentBlock: paraBlock,
      });

      if (
        (prevParaInitialLevel !== prevParaCurrLevel &&
          prevParaCurrLevel <= level &&
          prevParaInitialLevel <= currParaInitialLevel) ||
        (prevParaParent &&
          prevParaParent.type !== 'list_item' &&
          prevParaCurrLevel === level &&
          currParaInitialLevel !== level)
      ) {
        return false;
      }

      const doc = editor.value.document.getParent(parentUL.key);
      let indexOful = doc.nodes.toArray().indexOf(parentUL);
      const initialnodes = parentUL.nodes
        .toArray()
        .slice(0, indexOfParentListItem);
      const paragraphnodes = paraBlock;
      let childnodes = [];
      if (parentListItem.nodes.toArray()[1])
        childnodes = parentListItem.nodes.toArray()[1].nodes.toArray();
      const laternodes = [
        ...childnodes,
        ...parentUL.nodes
          .toArray()
          .slice(indexOfParentListItem + 1, parentULSize),
      ];
      [initialnodes, paragraphnodes, laternodes].forEach((element) => {
        if (Array.isArray(element) && element.length > 0) {
          const tempul = Block.create({
            type: 'unordered_list',
            nodes: element,
          });
          editor.insertNodeByKey(doc.key, indexOful, tempul);
          indexOful += 1;
        }
        if (element.type === 'paragraph') {
          editor.insertNodeByKey(doc.key, indexOful, element);
          indexOful += 1;
        }
      });
      editor.removeNodeByKey(parentUL.key);
      editor.select(selection);
      return true;
    }

    return false;
  }

  if (indexOfParentListItem === 0) return false;

  if (indexOfParentListItem > 0 && !shiftKey) {
    if (
      parentUL.nodes.toArray()[indexOfParentListItem - 1].nodes.toArray()[1]
    ) {
      const parentULNodesArray = parentUL.nodes.toArray();
      const newparent =
        parentULNodesArray[indexOfParentListItem - 1].nodes.toArray()[1];
      editor.moveNodeByKey(
        parentListItem.key,
        newparent.key,
        newparent.nodes.toArray().length + 1,
      );

      return true;
    }

    editor.withoutNormalization(() => {
      editor.wrapBlockByKey(parentListItem.key, 'unordered_list');
      const updatedUL = editor.value.document.getParent(
        editor.value.document.getParent(paraBlock.key).key,
      );
      const previousParagraph = document.getPreviousBlock(parentListItem.key);
      const parentOfParagraph = document.getParent(previousParagraph.key);
      const lastIndex = parentOfParagraph.nodes.size;
      try {
        editor.moveNodeByKey(updatedUL.key, parentOfParagraph.key, lastIndex);
      } catch (err) {
        Logger.LogError(err);
      }
    });
    return true;
  }

  return false;
};
